"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../st/st");
var injection_strategy_1 = require("./enum/injection-strategy");
exports.INJECTION_STRATEGY = "INJECTION_STRATEGY";
// for st.enable(di, ...)
exports.di = null;
if (!st_1.st.di) {
    st_1.st.di = {
        singletonInstanceRegistry: {},
        /**
         * Instantiates a class while taking care of DI configuration
         */
        newInstance: function (factoryFn, injectionStrategy, constructorArgument) {
            var newInstance = factoryFn(constructorArgument);
            if (injectionStrategy == injection_strategy_1.InjectionStrategy.SINGLETON) {
                st_1.st.di.singletonInstanceRegistry[newInstance.constructor.name] = newInstance;
            }
            return newInstance;
        },
        defaultFactoryFn: function (ctor, constructorArgument) { return function () { return new ctor(constructorArgument); }; },
        /**
         * Returns an instance as SINGLETON or FACTORY
         * @param originalCtor Constructor of the class to inject
         * @param constructorArgument Arbitrary first constructor argument for instantiation
         */
        get: function (originalCtor, constructorArgument) {
            if (!originalCtor || !originalCtor[exports.INJECTION_STRATEGY])
                return;
            var _a = originalCtor[exports.INJECTION_STRATEGY], injectionStrategy = _a.injectionStrategy, factoryFn = _a.factoryFn;
            var instance;
            if (injectionStrategy === injection_strategy_1.InjectionStrategy.SINGLETON &&
                st_1.st.di.singletonInstanceRegistry[originalCtor.name]) {
                instance = st_1.st.di.singletonInstanceRegistry[originalCtor.name];
            }
            else {
                instance = st_1.st.di.newInstance(factoryFn || st_1.st.di.defaultFactoryFn(originalCtor, constructorArgument), injectionStrategy, constructorArgument);
            }
            return instance;
        }
    };
    // assign functional API
    st_1.st.inject = st_1.st.di.get;
}
else {
    if (process.env.NODE_ENV === 'development') {
        st_1.st.warn('Module di is loaded twice. Check for duplicate famework import!');
    }
}
//# sourceMappingURL=di.js.map